import {BaseContainerModel} from '../../base-container.model';

import {bl_wf_issue_type_ext_RowClass} from "../../../dbschema/bl_wf_issue_type_ext.model";
import {bl_wf_issue_type_hdr_RowClass, bl_wf_issue_type_hdr_RowInterface} from "../../../dbschema/bl_wf_issue_type_hdr.model";

export class WfIssueTypeContainerModel extends BaseContainerModel {
  bl_wf_issue_type_hdr: bl_wf_issue_type_hdr_RowInterface = new bl_wf_issue_type_hdr_RowClass();
  bl_wf_issue_type_exts: bl_wf_issue_type_ext_RowClass[] = [];
}
